// extracted by mini-css-extract-plugin
export default {"container":"NoInternetConnection_container__9pPAR","innerContainer":"NoInternetConnection_innerContainer__e5Lmo","text":"NoInternetConnection_text__yzR5g"};